import React from "react";

import { Helmet } from "react-helmet";

import { IikoIntegration } from "features/IikoIntegration";
import { MenuScopeFromRouteProvider } from "shared/context/MenuScopeContext";
import { PageTitle } from "shared/ui";

const TITLE = "Интеграция с iiko";

// Тонкая обёртка над фичей: ставит chrome страницы и отдаёт всё остальное features/IikoIntegration.
const IikoIntegrationPage = () => {
    return (
        <>
            <PageTitle>{TITLE}</PageTitle>
            <Helmet title={TITLE} />
            <MenuScopeFromRouteProvider>
                <IikoIntegration />
            </MenuScopeFromRouteProvider>
        </>
    );
};

export default IikoIntegrationPage;
